import { Identifier } from "@tozd/identifier"

import { Namespace } from "@/namespace"

// Document IDs of the static pages.
export const ABOUT = (await Identifier.from(Namespace, "PAGE", "ABOUT")).toString()
export const TERMS_OF_SERVICE = (await Identifier.from(Namespace, "PAGE", "TERMS_OF_SERVICE")).toString()
export const PRIVACY_POLICY = (await Identifier.from(Namespace, "PAGE", "PRIVACY_POLICY")).toString()
export const ACCESSIBILITY_STATEMENT = (await Identifier.from(Namespace, "PAGE", "ACCESSIBILITY_STATEMENT")).toString()
